import { render, staticRenderFns } from "./d-card2.vue?vue&type=template&id=cad85b00&scoped=true"
import script from "./d-card2.vue?vue&type=script&lang=js"
export * from "./d-card2.vue?vue&type=script&lang=js"
import style0 from "./d-card2.vue?vue&type=style&index=0&id=cad85b00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad85b00",
  null
  
)

export default component.exports